/**
 * De stijlen die meer dan één scherm gebruikt, één keer.
 *
 * Elk scherm spreidt dit object in zijn eigen `styles` uit en zet daar zijn
 * eigen stijlen achter: `const styles = { ...gedeeld, ...eigen }`. Wat een
 * scherm zelf definieert, wint. Er staat hier alleen wat in twee of drie
 * schermen letterlijk gelijk was; stijlen die op elkaar lijken maar niet
 * gelijk zijn (de header, het invoerveld, de knop Opslaan) staan nog per
 * scherm, en wachten op het moment dat iemand beslist welke de goede is.
 *
 * De opmaak is inline (JavaScript-objecten), zoals het al was. Dat werkt, de
 * bouw heeft er geen stap voor nodig, en het staat naast de code die het
 * gebruikt.
 */
import { kleur } from './tokens';

export const gedeeld = {
  // de pagina en de kop
  container: { minHeight: '100vh', background: 'white' },
  logoutBtn: { padding: '8px 16px', background: kleur.rood, color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer' },
  tab: { padding: '16px 24px', border: 'none', background: 'none', cursor: 'pointer', fontSize: '15px', color: kleur.stil, outline: 'none' },
  tabActive: { padding: '16px 24px', border: 'none', background: 'none', cursor: 'pointer', fontSize: '15px', color: kleur.inkt, borderBottom: `3px solid ${kleur.accent}`, fontWeight: 'bold', marginBottom: '-1px', outline: 'none' },
  // lijst links, detail rechts
  splitView: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '24px' },
  listPanel: { background: 'white', borderRadius: '12px', padding: '24px', border: '1px solid black' },
  detailPanel: { background: 'white', borderRadius: '12px', padding: '24px', border: '1px solid black' },
  panelHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' },
  list: { listStyle: 'none', padding: 0 },
  listItem: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 16px', borderRadius: '8px', marginBottom: '8px', cursor: 'pointer', background: kleur.vlak },
  empty: { color: kleur.stiller, fontStyle: 'italic' },
  subheader: { margin: 0, color: kleur.stil },
  // formulieren
  form: { marginBottom: '16px', padding: '16px', background: kleur.vlak, borderRadius: '8px' },
  cancelBtn: { padding: '8px 16px', background: kleur.stiller, color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer' },
  // overig
  gesprekVan: { fontWeight: 'bold', marginRight: '6px' },
};
